'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TraceTypeWaterfallIcon = function TraceTypeWaterfallIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 60 60' }, props),
        _react2.default.createElement('path', { fill: '#119dff', d: 'M13 18.66h6.27v29.33H13z' }),
        _react2.default.createElement('path', { fill: '#09ffff', d: 'M20.59 18.67h5.65v7.23h-5.65zM34.36 11.83h5.42v24.11h-5.42z' }),
        _react2.default.createElement('path', { fill: '#119dff', d: 'M27.4 25.9h5.45v10.05H27.4zM40.95 11.83h6.19V48h-6.19z' }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#119dff', d: 'M13 18.53h13.31M27.47 35.65h12.32M34.41 12.06h12.73M20.52 25.61h12.32', strokeMiterlimit: '10', strokeWidth: '.75' })
    );
};

exports.default = TraceTypeWaterfallIcon;